import request from '@/utils/request'

/**
 * 获取供应链商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listChainProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainProduct.listChainProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取商品详情
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryProductDeatil(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainProduct.queryProductDeatil',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取商品评论
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryProductComments(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainProduct.queryProductComments',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除商品
 * @param {Object} data 删除参数
 * @returns {Promise} Promise对象
 */
export function deleteChainProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainProduct.deleteChainProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存采购订单
 * @param {Object} data 订单数据
 * @returns {Promise} Promise对象
 */
export function saveChainInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainInoutOrder.saveChainInoutOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export default {
  listChainProduct,
  queryProductDeatil,
  queryProductComments,
  deleteChainProduct,
  saveChainInoutOrder
}